import React from 'react';
import T from 'prop-types';

const LINE_WIDTH = 2;

const getShadowDepth = (mouseAway, isMax, isMin) => {
  if (!isMin && !isMax) {
    return 0;
  }

  if (isMax) {
    return Math.min(60, mouseAway / 5);
  }
  if (isMin) {
    return Math.min(60, -mouseAway / 5);
  }
};

const AnchorLine = ({ offsetLeft, type, active = false, isMax, isMin, mouseAway }) => {
  const shadowSize = isMin ? '5px' : isMax ? '-5px' : null;
  const showShadow = isMin || isMax || mouseAway > 0;
  const shadowDepth = getShadowDepth(mouseAway, isMax, isMin);
  // when postroll is all the way at the end, then the line width start at the edge of the container, which makes it invisible.
  // Because of this, we need to substract the line width
  const leftPos = isMax ? offsetLeft - LINE_WIDTH : offsetLeft;
  return (
    <div
      data-testid="anchor-line"
      style={{
        left: leftPos,
        boxShadow: showShadow && `${shadowSize} 0px 8px 3px rgba(80,80,80,${shadowDepth / 100})`,
      }}
      className={` ${type ? `ads-marker-tag--${type}` : ''} ${
        active ? 'ads-marker-tag--active' : ''
      } marker-anchor-line`}
    />
  );
};

AnchorLine.propTypes = {
  type: T.string.isRequired,
  offsetLeft: T.number.isRequired,
  active: T.bool,
  isMax: T.bool,
  isMin: T.bool,
  mouseAway: T.number,
};

export default AnchorLine;
